/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_BalanceInputs */

const en_settings_credits_balance = /** @type {(inputs: Settings_Credits_BalanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balance`)
};

/**
* | output |
* | --- |
* | "Balance" |
*
* @param {Settings_Credits_BalanceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_credits_balance = /** @type {((inputs?: Settings_Credits_BalanceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_BalanceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_credits_balance(inputs)
});
export { settings_credits_balance as "settings.credits.balance" }